import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 화면마다 제목·대표 주소(canonical) 넣기 (2026-10-12).
 * 모든 화면이 같은 제목이라 구글이 '대표 주소 없는 중복 페이지'로 봤음.
 * 곡 화면(/notes/..)은 서버(seo.php)와 NotePlayer 가 따로 넣으므로 건드리지 않는다.
 */
const BRAND = '코드스코어';
const TITLES: [RegExp, string][] = [
  [/^\/$/, '코드스코어 - 기타 코드 악보'],
  [/^\/chart\/?$/, '인기 TOP 100 기타 코드 악보'],
  [/^\/recent\/?$/, '새로 올라온 기타 코드 악보'],
  [/^\/hotclip\/?$/, '핫클립 - 인기 기타 연주 영상'],
  [/^\/pricing\/?$/, '구독 안내'],
  [/^\/download\/?$/, '앱 다운로드'],
  [/^\/faq\/?$/, '자주 묻는 질문'],
  [/^\/howto\/?$/, '사용 방법'],
  [/^\/request\/?$/, '악보 신청'],
  [/^\/tuner\/?$/, '기타 튜너'],
  [/^\/login\/?$/, '로그인'],
  [/^\/auth\/register\/?$/, '회원가입'],
  [/^\/policy\/service\/?$/, '이용약관'],
  [/^\/policy\/privacy\/?$/, '개인정보 처리방침'],
];

function setTag(sel: string, make: () => HTMLElement, attr: string, value: string | null) {
  let el = document.head.querySelector(sel) as HTMLElement | null;
  if (value === null) { if (el) el.remove(); return; }
  if (!el) { el = make(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
}

const PageMeta: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/notes/')) {
      const r = document.head.querySelector('meta[name="robots"]'); if (r) r.remove();
      return;
    }
    const hit = TITLES.find(([re]) => re.test(pathname));
    if (hit) document.title = pathname === '/' ? hit[1] : `${hit[1]} | ${BRAND}`;
    else document.title = '코드스코어, 기타코드악보 열람 서비스';
    // 대표 주소: 목록에 있는 화면만. 검색 결과·내 화면은 검색에 안 올림
    const link = () => { const l = document.createElement('link'); l.setAttribute('rel', 'canonical'); return l; };
    const meta = () => { const m = document.createElement('meta'); m.setAttribute('name', 'robots'); return m; };
    setTag('link[rel="canonical"]', link, 'href', hit ? `https://chordscore.com${pathname === '/' ? '/' : pathname.replace(/\/$/, '')}` : null);
    setTag('meta[name="robots"]', meta, 'content', hit ? null : 'noindex');
  }, [pathname]);
  return null;
};

export default PageMeta;
